import React, { useCallback, useMemo, useState } from 'react';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import FilledInput from '@mui/material/FilledInput';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import LoadingSvgIcon from '../svg/LoadingSvgIcon';
import { search } from '../api';

const styles = {
  inputRoot: {
    '&::before': {
      display: 'none',
    },
    '&::after': {
      display: 'none',
    },
  },
  input: {
    backgroundColor: '#ecf1f4',
    borderRadius: '4px',
    padding: '10px 16px',
    fontSize: '14px',
    letterSpacing: '0.8px',
    color: '#000',
    '&::placeholder': {
      fontSize: '14px',
      fontWeight: '300',
      fontStyle: 'italic',
      letterSpacing: '0.8px',
      color: '#000',
      opacity: '0.5',
    },
  },
  button: {
    transition: 'all 0.3s ease-in, width 0s, height 0s, margin 0s',
    height: '40px',
    '&.Mui-disabled': {
      backgroundColor: '#ecf1f4 !important',
      color: 'rgba(78, 107, 124, 0.5) !important',
      stroke: 'rgba(78, 107, 124, 0.5)',
      fill: 'rgba(78, 107, 124, 0.5)',
    },
  },
};

const SearchInput = props => {
  const { loading, setLoading, setError, setData } = props;

  const [query, setQuery] = useState('');

  const handleQueryChange = e => setQuery(e.target.value);

  const handleSubmit = useCallback(
    e => {
      e.preventDefault();
      setLoading(true);
      setData(null);
      setError('');

      search(query)
        .then(response => {
          setData(response.data);
        })
        .catch(err => {
          setError(err.message);
        })
        .finally(() => setLoading(false));
    },
    [query, setData, setError, setLoading]
  );

  const isDisabled = useMemo(() => loading || !query, [loading, query]);

  return (
    <form onSubmit={handleSubmit}>
      <Stack direction="row" spacing={2} my={5}>
        <Box flex={1}>
          <FilledInput
            sx={styles.inputRoot}
            inputProps={{ 'data-testid': 'search-input', sx: styles.input }}
            placeholder="Search for .."
            value={query}
            disabled={loading}
            onChange={handleQueryChange}
            fullWidth
          />
        </Box>
        <Button
          variant="contained"
          type="submit"
          sx={styles.button}
          disabled={isDisabled}
          endIcon={
            loading ? (
              <LoadingSvgIcon width="21px" height="21px" />
            ) : (
              <SearchIcon fontSize="large" />
            )
          }
        >
          {loading ? 'Loading...' : 'Search'}
        </Button>
      </Stack>
    </form>
  );
};

export default SearchInput;
